<form [formGroup]="vkgLimitedForm()" novalidate class="ap-personal-details ap-grid-cols-1 ap-grid ap-gap-2 ap-gap-gt-sm-4">
    <ap-personal-details-limited
        cclass="ap-display-block ap-margin-bottom-2"
        [contentKeyMap]="contentKeyMap()"
        [control]="limitedForm"
    ></ap-personal-details-limited>
    <div class="ap-grid ap-grid-cols-1 ap-grid-cols-gt-sm-4 ap-gap-gt-sm-5 ap-grid-margin-fix">
        <ap-date-input
            [label]="'vkg.limited.dateOfBirth.label' | apKeyOverride: contentKeyMap() | apContent"
            name="dateOfBirth"
            [formControl]="vkgLimitedForm().controls['dateOfBirth'] | apFormControl"
            [maxDate]="maxDate()"
            [minDate]="minDate()"
            startView="multi-year"
            [messages]="errorMessages"
            class="ap-col-span-gt-sm-2"
        >
        </ap-date-input>
    </div>
</form>
